import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  padding: 0 0em 0 0em;
  width: fit-content;
  height: fit-content;
  border-radius: 0.3em;
  overflow: hidden;
  animation: opacityAnimationIn 0.3s forwards;
  z-index: 30;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.38) !important;
  background: ${Colors.Color1};
  margin-bottom: 0.5em;

  .errorHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:  0em 0em 1em 0em;

    .title-select {
      border-radius: 0.3em;
      padding: 0.15em 0.8em 0.15em 0.8em;
      background: ${Colors.Color25};

      p {
        color: ${Colors.Color13};
        font-size: 0.7em;
        font-weight: 800;
      }
    }
  }

  .errorBody {
    position: relative;
    width: 14em;
    background: ${Colors.Color1};
    border-radius: 0.3em;
    padding: 1em 1.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    span.select {
      position: absolute;
      top: 2%;
      left: 0em;
      background: ${Colors.Color13};
      width: 0.25em;
      height: 96%;
      border-radius: 1em;
    }

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${Colors.Color13};

      i {
        font-size: 0.6em;
      }

      p {
        font-size: 0.6em;
        font-weight: 800;
        line-height: normal;
        margin-left: 0.2em;
      }
    }

    .message {
      color: ${Colors.Color28};
      font-size: 0.7em;
      font-weight: 600;
      line-height: normal;
    }
  }
`;
